import { Component, OnInit } from '@angular/core';
import { User } from "../../core/classes/user";
import { AppConfigService } from 'src/app/app-config.service';
import { PageMetaService } from "../../utils/page-meta/page-meta.service";
import RU from '../../../assets/i18n/RU.json';
import EN from '../../../assets/i18n/EN.json';
import { TranslateService } from '@ngx-translate/core';
import { IdDirection, IdSection } from 'src/app/constants';

@Component({
  selector: 'app-structure',
  templateUrl: './structure.component.html',
  styleUrls: ['./structure.component.scss']
})
export class StructureComponent implements OnInit {
  public user: User;
  public isTraderActive: boolean = false;
  public isWorkerActive: boolean = false;

  public strSessionShedule: string;
  public strSessions: string;
  public strSessionsTemplate: string;
  public strModels: string;
  public strRules: string;
  public strAuctions: string;

  public readonly IdDirection = IdDirection; 
  public readonly IdSection = IdSection;

  constructor(
    private config: AppConfigService,
    private pageMeta: PageMetaService,
    public translate: TranslateService,
  ) { }

  private setBrowserTabInfo(): void {
    const LANDING_PAGE =
      this.translate.store.currentLang === 'RU'
        ? RU['structure'].structureHead
        : EN['structure'].structureHead;

    const faviconUrl = 'assets/img/icons/logo.svg';
    this.pageMeta.setPageMeta(null, LANDING_PAGE, faviconUrl);
  }

  ngOnInit(): void {
    this.user = JSON.parse(localStorage.getItem('user') || '{}');
    if(this.user?.IsWorker){
      this.isTraderActive = false;
      this.isWorkerActive = true;
    }
    this.setBrowserTabInfo();
    this.strSessionShedule = `${this.config.host}${this.config.orderMan}sessions-schedule`;
    this.strSessions = `${this.config.host}${this.config.sessions}/sessions/management#schedule`;
    this.strSessionsTemplate = `${this.config.host}${this.config.sessions}/sessions/management#templates`;
    this.strModels = `${this.config.host}${this.config.sessions}/demands/management#models`;
    this.strRules = `${this.config.host}${this.config.sessions}/demands/management#rules`;
    this.strAuctions = `${this.config.host}${this.config.auctions}`
  }

  public goToCatalog(direction: number): void {
    const baseUrl = `${this.config.host}${this.config.orderMan}/catalog`;

    const queryParams = new URLSearchParams({
      direction: String(direction)
    });

    window.location.href = `${baseUrl}?${queryParams.toString()}`;
  }

  public goToOffersMan(sectionId: number): void {
    const baseUrl = `${this.config.host}${this.config.orderMan}/offer-management`;

    const queryParams = new URLSearchParams({
      idSection: String(sectionId)
    });

    window.location.href = `${baseUrl}?${queryParams.toString()}`;
  }

  goToLink(str){
     window.open(str, '_blank');
   // window.location.href = str;
  }

}
